import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3EA0D516-133D-4A5E-865B-82B7CC2763D5
 * name google-hangouts
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-hangouts.svg
 * tags
 * - Brand / Logo 
 */
export const GoogleHangoutsIcon = createSvgIcon(<><path d="M15,11L14,13H12.5L13.5,11H12V8H15M11,11L10,13H8.5L9.5,11H8V8H11M11.5,2A8.5,8.5 0 0,0 3,10.5A8.5,8.5 0 0,0 11.5,19H12V22.5C16.86,20.15 20,15 20,10.5C20,5.8 16.19,2 11.5,2Z" /></>, 'GoogleHangoutsIcon');
export default GoogleHangoutsIcon